import { InjectionToken } from '@angular/core';

export interface EnvironmentToken {
  version: string;
  target: string;
  apiUrl: string;
  production: boolean;
  [key: string]: string | number | boolean;
}

/**
 * @example
 * Usage: 
 * In your module import the environment and provide it as a value to the token
 * import { environment } from '../environment'
 * import { ENVIRONMENT_TOKEN } from '@rx-applications/shared/utils'
 * 
 * Then in your module providers
 * providers: [..., { provide: ENVIRONMENT_TOKEN, useValue: environment }]
 */
export const ENVIRONMENT_TOKEN = new InjectionToken<EnvironmentToken>('environment-token');
